import { format, parseISO } from 'date-fns';

export const formatDate = (dateTime: string, dateFormat?: string) => {
    return format(parseISO(dateTime), dateFormat || 'dd MMMM yyyy');
};
